<div class="center-align">
    <img class="logo" *ngIf="selectedTheme === 'dark'" width="800" src="{{getLogoPath()}}" default="/assets/layout/images/logos/dark/fmx-onsite-logo.png">
    <img class="logo" *ngIf="selectedTheme === 'light'" width="800" src="{{getLogoPath()}}" default="/assets/layout/images/logos/light/fmx-onsite-logo.png">
    <input type="text" pInputText placeholder="Search applications..." [(ngModel)]="searchText">

    <div class="contain">
        <div class="app-card" *ngFor="let application of applications | customSearch: searchText" (click)="navigate(application)">
        <!-- <div class="app-card" *ngFor="let application of applications" (click)="navigate(application)"> -->
            <div class="card-back">
                <div class="card-contents">
                    <img src="/assets/layout/images/applications/{{selectedTheme}}/{{application.icon}}" default="/assets/layout/images/applications/{{selectedTheme}}/fallback.svg" />
                </div>
            </div>
            <div>{{application.displayName}}</div>
        </div>
    </div>
</div>
